import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { IoLocationOutline } from "react-icons/io5";
import { UserService } from "../../services/UserService";
import { APP_SETTINGS_PATHS } from "./paths";
import "../../assets/styles/app-preferences.css";

const dismissedKey = (homeId) => `home-address-card-dismissed:${homeId}`;
const isDismissed = (homeId) => {
  try {
    return Boolean(localStorage.getItem(dismissedKey(homeId)));
  } catch (error) {
    return false;
  }
};

// On Home, for owners of a home with no address yet
// (app/screens/HomeSettings/HomeAddressCard.js). It never blocks anything:
// "Not now" hides it for that home in this browser, and the address can still
// be added from Home's "+".
function HomeAddressCard({ house }) {
  const history = useHistory();
  const [show, setShow] = useState(false);
  const homeId = house?.id;
  const owner = house?.role === "owner";

  // Checked each time Home shows, so the card goes once an address is saved.
  useEffect(() => {
    let current = true;
    setShow(false);
    if (!owner || !homeId || isDismissed(homeId)) return undefined;
    UserService.getHomeAddress(homeId)
      .then((result) => current && result && result.address === null && setShow(true))
      .catch(() => {
        // no card when the address can't be read
      });
    return () => {
      current = false;
    };
  }, [owner, homeId]);

  if (!show) return null;

  const dismiss = () => {
    setShow(false);
    try {
      localStorage.setItem(dismissedKey(homeId), "1");
    } catch (error) {
      // it shows again next time
    }
  };

  return (
    <section className="hx-addr-card" aria-label="Home address">
      <div className="hx-addr-card-row">
        <IoLocationOutline className="hx-addr-card-icon" aria-hidden="true" />
        <div>
          <h2 className="hx-addr-card-title">Add your home's address</h2>
          <p className="hx-addr-card-text">It helps when we visit for service or a repair.</p>
        </div>
      </div>
      <div className="hx-addr-card-buttons">
        <button type="button" className="hx-addr-card-later" onClick={dismiss}>
          Not now
        </button>
        <button type="button" className="hx-btn" onClick={() => history.push(APP_SETTINGS_PATHS.HOME_ADDRESS)}>
          Add address
        </button>
      </div>
    </section>
  );
}

export default HomeAddressCard;
